import React from "react";
import { useTranslation } from "react-i18next";

export default function HaCreateProfile() {
  const { t } = useTranslation("help");

  return (
    <div className="endpoint-container">
      <a href="#create-profile" className="endpoint-title">
        {t("HaCreateProfile.title", "Create Profile")}
      </a>

      <pre className="code-block">
        <code>{`import requests
import json

API_KEY = ""  # ${t("HaCreateProfile.required", "Required")}
SESSION_KEY = ""  # ${t("HaCreateProfile.required", "Required")}
PROFILE_NAME = ""  # ${t("HaCreateProfile.required", "Required")}
PROFILE_DESCRIPTION = ""  # ${t("HaCreateProfile.optional", "Optional")}
ENDPOINT_CONFIG_ID = ""  # ${t("HaCreateProfile.required", "Required")}
PROFILE_TYPE = ""  # ${t("HaCreateProfile.required", "Required")}; ${t("HaCreateProfile.mustBeOneof")}: mcp_tester, dos_tester, rto, prompts_docs_llm, ai_model_attack_surface, regulation_compliance
PROFILE_CONFIG_FILE = ""  # ${t("HaCreateProfile.required", "Required")}; ${t("HaCreateProfile.nameofAnySix")}
RETRY_ATTEMPTS = 0  # ${t("HaCreateProfile.optional", "Optional")}

url = f"https://demo.whitehax.com/api/profiles-config/create/"

with open(PROFILE_CONFIG_FILE) as f:
    CONFIG = json.load(f)

payload = {
    "profile_name": PROFILE_NAME,
    "profile_description": PROFILE_DESCRIPTION,
    "endpoint_config_id": ENDPOINT_CONFIG_ID,
    "profile_type": PROFILE_TYPE,
    "retry_attempts": RETRY_ATTEMPTS,
    "config": json.dumps(CONFIG),
}

headers = {"Authorization": API_KEY, "X-Session-Key": SESSION_KEY}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)`}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 0;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 4;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
            overflow-x: auto;
          }
        }
      `}</style>
    </div>
  );
}